export const AVAILABLE_SERVICES = [{
    service_name: 'stocks_webhook',
    url: '/api/webhooks/stocks?api_token=<API_TOKEN>&format=<PDF|XLSX|JSON>',
    name: 'stocks.name',
    description: 'stocks.description',
    guide: 'stocks.guide',
    guide_url: '/guides/guia-servicio-existencias-extranet-clientes-ac.pdf'
}];
